import React from "react";

const Dashboard = () => {
    return (
        <div style={styles.container}>

            {/* ===== TOP CARDS ===== */}
            <div style={styles.cardRow}>
                <Card color="#2ecc71" title="50" subtitle="LIST OF CLIENTS" />
                <Card color="#3498db" title="20" subtitle="PARTNER REQUEST" />
                <Card color="#f39c12" title="15" subtitle="TOTAL ORDERS" />
                <Card color="#e74c3c" title="5" subtitle="PENDING ISSUES" />
            </div>

            {/* ===== MIDDLE SECTION ===== */}
            <div style={styles.middleRow}>

            </div>

        </div>
    );
};


// ===== REUSABLE CARD =====
const Card = ({ color, title, subtitle }) => (
    <div style={{ ...styles.card, background: color }}>
        <h2 style={styles.cardTitle}>{title}</h2>
        <p style={styles.cardSubtitle}>{subtitle}</p>
    </div>
);



// ===== STYLES =====
const styles = {
    container: {
        padding: "20px",
        background: "#f3f3f4",
        minHeight: "100vh",
    },

    /* ===== CARDS ===== */
    cardRow: {
        display: "flex",
        gap: "20px",
        marginBottom: "20px",
    },

    card: {
        flex: 1,
        color: "#fff",
        padding: "20px",
        borderRadius: "8px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    },

    cardTitle: {
        margin: 0,
        fontSize: "28px",
        fontWeight: "bold",
    },

    cardSubtitle: {
        marginTop: "5px",
        fontSize: "14px",
        letterSpacing: "1px",
    },

    /* ===== MIDDLE ===== */
    middleRow: {
        display: "flex",
        gap: "20px",
    },


};

export default Dashboard;